'use client';

import { FC, Fragment, PropsWithChildren, useState } from 'react';
import { HeaderSearchBarProps } from './types';
import { CatSearchForm } from '@blocks-react/components/SearchForm';
import {
  BlocksChangeEvent,
  BlocksSearchEvent
} from '@blocks-web-components/events';
import cx from 'classnames';
import styles from './HeaderSearchBar.module.scss';
import { Conditional } from '../../common';
import { CatIconSearch } from '@blocks-react/components/Icons/Search';

export const HeaderSearchBar: FC<PropsWithChildren<HeaderSearchBarProps>> = ({
  placeholder,
  onSearch,
  onChange,
  children,
  hideResults,
  isNavMenuUpdateFlag = false,
  isMobile,
  mobileBreakPoint,
  size = 'md',
  initialSearchValue = '',
  onBlMobileOverlayOpen,
  onBlMobileOverlayClose
}) => {
  const [searchValue, setSearchValue] = useState(initialSearchValue ?? '');
  const [isActive, setIsActive] = useState(false);
  const isSearchActive = isMobile ? isActive : !hideResults;
  const isEmpty = isMobile ? false : hideResults;
  const setSearchInputValue = (value: string) => {
    setSearchValue(value);
    return value?.toLowerCase().replace(/:/g, '');
  };

  const onChangeHandler = (event: BlocksChangeEvent) => {
    const searchInputValue = event.detail.value ?? '';
    const searchValue = setSearchInputValue(searchInputValue);
    onChange(searchValue, searchInputValue);
  };

  const onSearchHandler = (event: BlocksSearchEvent) => {
    const searchInputValue = event.detail.value ?? '';
    const searchValue = setSearchInputValue(searchInputValue);
    onSearch(searchValue, searchInputValue);
  };

  const onMobileOverlayOpen = () => {
    if (onBlMobileOverlayOpen) {
      onBlMobileOverlayOpen();
    }
    setIsActive(true);
  };

  const onMobileOverlayClose = () => {
    if (onBlMobileOverlayClose) {
      onBlMobileOverlayClose();
    }
    setIsActive(false);
  };

  return (
    <div
      className={cx(
        { 'mb-2': isMobile },
        { [styles['header-search-bar--width']]: !isMobile },
        'flex-grow-1'
      )}
    >
      <CatSearchForm
        status={undefined}
        size={size}
        className={styles['header-search-bar']}
        placeholder={placeholder}
        data-testid="cat-header-search-bar"
        onBlChange={onChangeHandler}
        onBlSearch={onSearchHandler}
        isEmpty={isEmpty}
        isActive={isSearchActive}
        mobileBreakPoint={mobileBreakPoint}
        onBlMobileOverlayOpen={onMobileOverlayOpen}
        onBlMobileOverlayClose={onMobileOverlayClose}
        position="bottom-start"
        value={searchValue}
        hideSearchIcon={!isMobile}
        hideText={isNavMenuUpdateFlag}
      >
        <Fragment key="search-input">
          <Conditional test={!!isMobile}>
            <CatIconSearch
              slot="before"
              data-testid="cat-header-search-icon"
              aria-label="Search"
            />
          </Conditional>
          {children}
        </Fragment>
      </CatSearchForm>
    </div>
  );
};
